import React from "react";
import styles from "./styles/IndustrialSolutions.module.css";
import Header from "../../shared/Header/Header";
import Footer from "../../shared/Footer/Footer";
import IndustrialSolutionsHero from "./IndustrialSolutionsHero";
import FoolproofSystem from "./FoolproofSystem";
import AndonSystems from "./AndonSystems";
import ScadaSystems from "./ScadaSystems";
import MesSystems from "./MesSystems";

export default function IndustrialSolutions() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <IndustrialSolutionsHero />
        <FoolproofSystem />
        <AndonSystems />
        <ScadaSystems />
        <MesSystems />
      </main>
      <Footer />
    </div>
  );
}
